/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "FolderSpan",
  "tagline": "让文件管理保持简洁有序",
  "favicon": "img/favicon.ico",
  "future": {
    "v4": {
      "removeLegacyPostBuildHeadAttribute": true,
      "useCssCascadeLayers": true,
      "siteStorageNamespacing": true,
      "fasterByDefault": true,
      "mdx1CompatDisabledByDefault": true
    },
    "faster": {
      "rspackBundler": false,
      "rspackPersistentCache": false,
      "swcJsLoader": true,
      "swcJsMinimizer": true,
      "swcHtmlMinimizer": true,
      "lightningCssMinimizer": true,
      "mdxCrossCompilerCache": true,
      "ssgWorkerThreads": true,
      "gitEagerVcs": true
    },
    "experimental_vcs": {},
    "experimental_router": "browser"
  },
  "url": "https://folderspan.com",
  "baseUrl": "/en/",
  "organizationName": "Qqv0V6ge",
  "projectName": "file-manager-docs",
  "onBrokenLinks": "throw",
  "i18n": {
    "defaultLocale": "zh-Hans",
    "locales": [
      "zh-Hans",
      "en"
    ],
    "localeConfigs": {
      "zh-Hans": {
        "label": "简体中文"
      },
      "en": {
        "label": "English"
      }
    },
    "path": "i18n"
  },
  "presets": [
    [
      "classic",
      {
        "docs": {
          "sidebarPath": "./sidebars.ts",
          "editUrl": "https://github.com/Qqv0V6ge/file-manager-docs/edit/master/",
          "showLastUpdateTime": true
        },
        "blog": false,
        "sitemap": {
          "ignorePatterns": [
            "/search",
            "/ai-docs",
            "/en/search",
            "/en/ai-docs"
          ],
          "lastmod": "date"
        },
        "theme": {
          "customCss": "./src/css/custom.css"
        }
      }
    ]
  ],
  "themes": [
    [
      "/home/webb/WebstormProjects/file-manager-docs/node_modules/@easyops-cn/docusaurus-search-local/dist/server/server/index.js",
      {
        "hashed": "filename",
        "language": [
          "en",
          "zh"
        ],
        "indexDocs": true,
        "indexBlog": false,
        "indexPages": false,
        "highlightSearchTermsOnTargetPage": true,
        "explicitSearchResultPath": true
      }
    ]
  ],
  "plugins": [
    null,
    null
  ],
  "themeConfig": {
    "image": "img/folderspan-social-card.png",
    "colorMode": {
      "respectPrefersColorScheme": true,
      "defaultMode": "light",
      "disableSwitch": false
    },
    "navbar": {
      "title": "FolderSpan",
      "logo": {
        "alt": "FolderSpan Logo",
        "src": "img/logo.svg",
        "srcDark": "img/logo-dark.svg",
        "width": 32,
        "height": 32
      },
      "items": [
        {
          "type": "docSidebar",
          "sidebarId": "tutorialSidebar",
          "position": "left",
          "label": "Tutorials"
        },
        {
          "to": "/download",
          "label": "Download",
          "position": "left",
          "activeBaseRegex": "^/(?:en/)?download/?$"
        },
        {
          "to": "/download/headless",
          "label": "Download (Headless)",
          "position": "left",
          "activeBaseRegex": "^/(?:en/)?download/headless/?$"
        },
        {
          "to": "/ai-docs",
          "label": "AI assistant",
          "position": "left"
        },
        {
          "to": "/web/",
          "label": "Web app",
          "position": "right"
        },
        {
          "href": "https://github.com/Qqv0V6ge/FolderSpan",
          "label": "GitHub",
          "position": "right"
        },
        {
          "type": "localeDropdown",
          "position": "right",
          "dropdownItemsBefore": [],
          "dropdownItemsAfter": []
        },
        {
          "type": "search",
          "position": "right"
        }
      ],
      "hideOnScroll": false
    },
    "footer": {
      "style": "dark",
      "links": [
        {
          "title": "Documentation",
          "items": [
            {
              "label": "Tutorials",
              "to": "/docs/intro"
            }
          ]
        },
        {
          "title": "Community",
          "items": [
            {
              "label": "572169725@qq.com",
              "href": "mailto:572169725@qq.com"
            }
          ]
        },
        {
          "title": "More",
          "items": [
            {
              "label": "GitHub",
              "href": "https://github.com/Qqv0V6ge/FolderSpan"
            }
          ]
        }
      ],
      "copyright": "Copyright © 2026 FolderSpan. Built with Docusaurus."
    },
    "prism": {
      "theme": {
        "plain": {
          "color": "#393A34",
          "backgroundColor": "#f6f8fa"
        },
        "styles": [
          {
            "types": [
              "comment",
              "prolog",
              "doctype",
              "cdata"
            ],
            "style": {
              "color": "#999988",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "opacity": 0.7
            }
          },
          {
            "types": [
              "string",
              "attr-value"
            ],
            "style": {
              "color": "#e3116c"
            }
          },
          {
            "types": [
              "punctuation",
              "operator"
            ],
            "style": {
              "color": "#393A34"
            }
          },
          {
            "types": [
              "entity",
              "url",
              "symbol",
              "number",
              "boolean",
              "variable",
              "constant",
              "property",
              "regex",
              "inserted"
            ],
            "style": {
              "color": "#36acaa"
            }
          },
          {
            "types": [
              "atrule",
              "keyword",
              "attr-name",
              "selector"
            ],
            "style": {
              "color": "#00a4db"
            }
          },
          {
            "types": [
              "function",
              "deleted",
              "tag"
            ],
            "style": {
              "color": "#d73a49"
            }
          },
          {
            "types": [
              "function-variable"
            ],
            "style": {
              "color": "#6f42c1"
            }
          },
          {
            "types": [
              "tag",
              "selector",
              "keyword"
            ],
            "style": {
              "color": "#00009f"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "color": "#F8F8F2",
          "backgroundColor": "#282A36"
        },
        "styles": [
          {
            "types": [
              "prolog",
              "constant",
              "builtin"
            ],
            "style": {
              "color": "rgb(189, 147, 249)"
            }
          },
          {
            "types": [
              "inserted",
              "function"
            ],
            "style": {
              "color": "rgb(80, 250, 123)"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "color": "rgb(255, 85, 85)"
            }
          },
          {
            "types": [
              "changed"
            ],
            "style": {
              "color": "rgb(255, 184, 108)"
            }
          },
          {
            "types": [
              "punctuation",
              "symbol"
            ],
            "style": {
              "color": "rgb(248, 248, 242)"
            }
          },
          {
            "types": [
              "string",
              "char",
              "tag",
              "selector"
            ],
            "style": {
              "color": "rgb(255, 121, 198)"
            }
          },
          {
            "types": [
              "keyword",
              "variable"
            ],
            "style": {
              "color": "rgb(189, 147, 249)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(98, 114, 164)"
            }
          },
          {
            "types": [
              "attr-name"
            ],
            "style": {
              "color": "rgb(241, 250, 140)"
            }
          }
        ]
      },
      "additionalLanguages": [],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "metadata": [],
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "baseUrlIssueBanner": true,
  "storage": {
    "type": "localStorage",
    "namespace": true
  },
  "onBrokenAnchors": "warn",
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "customFields": {},
  "scripts": [],
  "headTags": [],
  "stylesheets": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false,
  "markdown": {
    "format": "mdx",
    "mermaid": false,
    "emoji": true,
    "mdx1Compat": {
      "comments": false,
      "admonitions": false,
      "headingIds": false
    },
    "anchors": {
      "maintainCase": false
    },
    "hooks": {
      "onBrokenMarkdownLinks": "warn",
      "onBrokenMarkdownImages": "throw"
    }
  }
};
